var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8.868,
    height: 7.778,
    viewBox: "0 0 8.868 7.778",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "lobby-link-arrow",
    transform: "translate(-350.5 -3824.352)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lobby-link-arrow-1",
    d: "M3.889,0A.543.543,0,0,0,3.5.159L.16,3.5a.545.545,0,0,0,.77.77L3.889,1.315,6.848,4.274a.545.545,0,1,0,.77-.77L4.274.159A.543.543,0,0,0,3.889,0Z",
    transform: "translate(354.934 3824.352) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lobby-link-arrow-2",
    d: "M3.889,0A.543.543,0,0,0,3.5.159L.16,3.5a.545.545,0,0,0,.77.77L3.889,1.315,6.848,4.274a.545.545,0,1,0,.77-.77L4.274.159A.543.543,0,0,0,3.889,0Z",
    transform: "translate(359.368 3824.352) rotate(90)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4Ljg2OCIgaGVpZ2h0PSI3Ljc3OCIgdmlld0JveD0iMCAwIDguODY4IDcuNzc4Ij4NCiAgPGcgY2xhc3M9ImxvYmJ5LWxpbmstYXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNTAuNSAtMzgyNC4zNTIpIj4NCiAgICA8cGF0aCBjbGFzcz0ibG9iYnktbGluay1hcnJvdy0xIg0KICAgICAgZD0iTTMuODg5LDBBLjU0My41NDMsMCwwLDAsMy41LjE1OUwuMTYsMy41YS41NDUuNTQ1LDAsMCwwLC43Ny43N0wzLjg4OSwxLjMxNSw2Ljg0OCw0LjI3NGEuNTQ1LjU0NSwwLDEsMCwuNzctLjc3TDQuMjc0LjE1OUEuNTQzLjU0MywwLDAsMCwzLjg4OSwwWiINCiAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM1NC45MzQgMzgyNC4zNTIpIHJvdGF0ZSg5MCkiIC8+DQogICAgPHBhdGggY2xhc3M9ImxvYmJ5LWxpbmstYXJyb3ctMiINCiAgICAgIGQ9Ik0zLjg4OSwwQS41NDMuNTQzLDAsMCwwLDMuNS4xNTlMLjE2LDMuNWEuNTQ1LjU0NSwwLDAsMCwuNzcuNzdMMy44ODksMS4zMTUsNi44NDgsNC4yNzRhLjU0NS41NDUsMCwxLDAsLjc3LS43N0w0LjI3NC4xNTlBLjU0My41NDMsMCwwLDAsMy44ODksMFoiDQogICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNTkuMzY4IDM4MjQuMzUyKSByb3RhdGUoOTApIiAvPg0KICA8L2c+DQo8L3N2Zz4=";
export { ForwardRef as ReactComponent };